import Component from '@bythepixel/component-loader';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { eventThrottle } from '@Utility';

export default class SocialGallery extends Component {
  static selector = '[data-comp-social-gallery]';

  constructor(containerEl) {
    super(containerEl);

    this.splideSettings = {
      arrows: false,
      fixedHeight: 467,
      fixedWidth: 467,
      gap: 18,
      pagination: false,
      perMove: 1,
      perPage: 4,
      type: 'loop',
    };

    this.splide = new Splide(this.$container, this.splideSettings);

    this.events();
    window.addEventListener(
      'resize',
      eventThrottle(() => this.events()),
    );
  }

  events() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.splide.destroy();
    } else if (!this.splide.state.is(Splide.STATES.IDLE)) {
      this.splide.mount({
        AutoScroll,
      });
    }
  }
}
